import { render, staticRenderFns } from "./tpl-3.vue?vue&type=template&id=585a8b5d&scoped=true&"
import script from "./tpl-3.vue?vue&type=script&lang=js&"
export * from "./tpl-3.vue?vue&type=script&lang=js&"
import style0 from "./tpl-3.vue?vue&type=style&index=0&id=585a8b5d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585a8b5d",
  null
  
)

export default component.exports